import api from './api';

/**
 * Dateien (PDF, XML, CSV) laufen ueber denselben authentifizierten Weg wie
 * alle anderen Aufrufe: als Blob holen und ueber eine Objekt-URL oeffnen
 * oder speichern. Ein direkter <a href="/api/..."> haette keinen Bearer.
 */
export async function blobHolen(url: string, params?: Record<string, unknown>): Promise<Blob> {
  const response = await api.get(url, { responseType: 'blob', params });
  return response.data instanceof Blob ? response.data : new Blob([response.data]);
}

/** Speichert einen Blob unter dem angegebenen Dateinamen (a.click()). */
export function blobSpeichern(blob: Blob, dateiname: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = dateiname;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

/** Oeffnet ein PDF in einem neuen Tab. */
export function blobOeffnen(blob: Blob, typ = 'application/pdf'): void {
  const url = URL.createObjectURL(new Blob([blob], { type: typ }));
  window.open(url, '_blank');
  // Erst freigeben, wenn der neue Tab die Datei geholt hat.
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

export async function herunterladen(url: string, dateiname: string, params?: Record<string, unknown>): Promise<void> {
  blobSpeichern(await blobHolen(url, params), dateiname);
}

export async function pdfOeffnen(url: string): Promise<void> {
  blobOeffnen(await blobHolen(url));
}
